module.exports = __webpack_public_path__ + "static/img/example7.22bb71a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/chainmanage/image/example7.jpg
// module id = 713
// module chunks = 1